import { useState } from "react";
import  IoCopyOutline  from "@mui/material/Card";

// Also install this npm i --save-dev @types/react-lottie
import Lottie from "react-lottie";
import { cn } from "../lib/utils";
import "./bento.css"
import { BackgroundGradientAnimation } from "./BackgroundGradientAnimation";

import animationData from "../data/confetti.json";
import animationData2 from "../data/globe spinning.json";
import animationData3 from "../data/fullstackMongoDb.json";


export const BentoGrid = ({ className, children }) => {
  return (
    <div
      className="bentoz"
    >
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  id,
  title,
  description,
  img,
  imgClassName,
  titleClassName,
  spareImg,
  scrollToElement,
}) => {
  const leftLists = ["ReactJS", "Express", "Typescript"];
  const rightLists = ["VueJS", "NuxtJS", "GraphQL"];

  const [copied, setCopied] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptions3 = {
    loop: true,
    autoplay: true,
    animationData: animationData3,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleCopy = () => {
    const text = "eliyakidulani@gmail.com";
    navigator.clipboard.writeText(text);
    setCopied(true);
  };

  return (
    <div
      className={`${className}`}
      style={{
        background: "rgb(4,7,29)",
        backgroundColor:
          "linear-gradient(90deg, rgba(4,7,29,1) 0%, rgba(12,14,35,1) 100%)",
      }}
    >

      <div className={`${id === 6 && "flex justify-center"} h-full`}>
        <div className="w-full h-full absolute">
          {img && (
            <img
              src={img}
              alt={img}
              className={cn(imgClassName, "object-contain")}
            />
          )}
        </div>

        <div
          className={`absolute right-0 -bottom-5 ${
            id === 5 && "w-full opacity-80"
          } `}
        >
          {spareImg && (
            <img
              src={spareImg}
              alt={spareImg}
              className="object-contain"
            />
          )}
        </div>

        {id === 5 && (
          <BackgroundGradientAnimation>
            <div className="absolute z-50 inset-0 flex items-center justify-center text-white font-bold px-4 pointer-events-none text-3xl text-center md:text-4xl lg:text-7xl"></div>
          </BackgroundGradientAnimation>
        )}

<div className={cn(titleClassName, "bento-container")}>
  <div className="bento-description">
    {description}
  </div>

  <div className={titleClassName} >
    {title}
  </div>

  {/*id === 3 && (
    <div className="bento-lists-container">
      <div className="bento-left-lists">
        {leftLists.map((item, i) => (
          <span key={i} className="bento-list-item">
            {item}
          </span>
        ))}
        <span className="bento-list-item-placeholder"></span>
      </div>
      <div className="bento-right-lists">
        <span className="bento-list-item-placeholder"></span>
        {rightLists.map((item, i) => (
          <span key={i} className="bento-list-item">
            {item}
          </span>
        ))}
      </div>
    </div>
  )*/}

  {id === 5 && (
    <div className="bento-footer">
      <div className={`bento-lottie ${copied ? "visible" : "hidden"}`}>
        <Lottie options={defaultOptions} height={200} width={400} />
      </div>
      <a id="about">
        <div className="copybutt" >
          <h2 className="copytext" onClick={() => scrollToElement("contact")} >
            contact us
          </h2>
          <div className="copy-icon"><IoCopyOutline fontSize="inherit" /></div>
        </div>
      </a>
    </div>
  )}
</div>

   {id === 2 && (
    <div className="worlds" >
     <Lottie options={defaultOptions2}  />
    </div>
    
   )}
   {id === 3 && (
    <div className="worlds" >
     <Lottie options={defaultOptions3}  />
    </div>
    
   )}
   {id === 2 && (
    <div className="darknesshere" >

    </div>
   )}

      </div>

    </div>
  );
};
